import { useLocaleStore } from '~/stores/locale'

export const useAccountMenu = () => {
  const localeStore = useLocaleStore()
  const { canSeeRewards } = useRewardsVisibility()

  const customerMenu = [
    'settings',
    'address',
    'payment',
    'orders',
    'lists'
  ]

  const customerMenuWithFeatures = computed(() => {
    const menu = [...customerMenu, 'subscriptions', 'demonstrator']
    if (canSeeRewards.value) {
      menu.push('rewards')
    }
    menu.push('notifications')
    return menu
  })

  const demoMenu = computed(() => {
    const menu = ['settings', 'address', 'billing']
    if (localeStore.isEuCountry) {
      menu.push('vatRegistration')
    }
    if (canSeeRewards.value) {
      menu.push('rewards')
    }
    menu.push('notifications')
    menu.push('orders', 'links', 'lists', 'subscriptions', 'agreements')
    return menu
  })

  const { isDemo } = useSAuthState()
  const router = useRouter()
  // Keep hybrid-migration menu drift from turning a missing named route into an SSR 500.
  // Registered account pages appear automatically under the existing route-name convention.
  const routeName = (page: string) => `account-${page.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase()}`
  const menu = computed(() =>
    (isDemo.value ? demoMenu.value : customerMenuWithFeatures.value).filter((page) => router.hasRoute(routeName(page)))
  )
  return menu
}

// Ids shared by the account nav (links) and AccountSettingsPage (content panel). AB#60100
export const ACCOUNT_PANEL_ID = 'account-panel'
export const ACCOUNT_TITLE_ID = 'account-title'

export const accountLinkId = (menuType: string, page: string) => `${menuType}-link-${page}`

export const accountPageSlug = (page: string) => page.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase()

// Path segments under `/<menuType>/`, so a locale prefix does not matter.
export const accountSectionPath = (path: string, menuType: string) =>
  (path.split(`/${menuType}/`)[1] ?? '').split('/').filter(Boolean)

// The menu entry whose section the path is in, so the nav links, the mobile
// menu and the content panel agree on which page is current.
export const accountCurrentPage = (path: string, menuType: string, menuList: string[]) => {
  const section = accountSectionPath(path, menuType)[0]
  return menuList.find(page => accountPageSlug(page) === section)
}
